__turbopack_context__.v({
  "fundraiserimage": "FundraiserHeader-module-scss-module__Ttaq3W__fundraiserimage",
  "header": "FundraiserHeader-module-scss-module__Ttaq3W__header",
  "headerimage": "FundraiserHeader-module-scss-module__Ttaq3W__headerimage",
});
